import { Button, ImageList, ImageListItem } from "@mui/material";
import Swiper from "./swiper";
import Dishe from "../sections/dishe";
import i18next, { t } from "i18next";
import calories from "../../../images/Fire.svg";
import time from "../../../images/Timer.svg";

import {
  getBadgeStatusClass,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../../../utility";
import { Badge } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
const MianInfo = ({
  item,
  sympoleData,
  selected,
  calorie,
  tableQr,
  tableName,
  updataItem,
  favorites,
  handleFavorite,
  handleSelected,
  open,
  handleOrder,
  order_ability,
  treeData,
}) => {

  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const onImageError = (e) => {
    e.target.src = no_image;
  };


  const openItem = (comboItem) => {
    if (item.sold_out !== 1) {
      if (location.pathname === `/${tableName}/${tableQr}/sections`) {
        navigate(
          `/${tableName}/${tableQr}/items?item=${comboItem?.id}&t=${params.get(
            "t"
          )}&selectedLang=${localStorage.getItem("lang")}`,
          {
            state: { from: location.pathname },
          }
        );
      } else {

        updataItem(comboItem);
      }
    }
  };

  return (
    <div className={`min-vh-75`}>
      <div className="head mt-4 px-3">
        {item.label_name ? (
          <p className="mb-2 alignByLang">
            <Badge
              className={` ${getBadgeStatusClass(
                item.label_name
              )} p-2 font-size-12 sub-font m-1`}
            >
              {item.label_name || "New"}
            </Badge>
            {item?.sold_out !== 1 ? (
              <Badge
                className={`${localStorage.getItem("theme") === "dark"
                  ? "instock-badge-style-dark"
                  : "instock-badge-style"
                  }  p-2 font-size-12 sub-font m-1`}
              >
                {t("in stock")}
              </Badge>
            ) : (
              <Badge
                className={`${localStorage.getItem("theme") === "dark"
                  ? "outofinstock-badge-style-dark"
                  : "outofinstock-badge-style"
                  }  p-2 font-size-12 sub-font m-1`}
              >
                {t("Out of stock")}
              </Badge>
            )}
          </p>
        ) : (
          <p className="mb-2 alignByLang">
            <Badge
              className={` ${getBadgeStatusClass(
                "New"
              )} p-2 font-size-12 sub-font m-1`}
            >
              {t("New")}
            </Badge>
            {item?.sold_out !== 1 ? (
              <Badge
                className={`${localStorage.getItem("theme") === "dark"
                  ? "instock-badge-style-dark"
                  : "instock-badge-style"
                  }  p-2 font-size-12 sub-font m-1`}
              >
                {t("in stock")}
              </Badge>
            ) : (
              <Badge
                className={`${localStorage.getItem("theme") === "dark"
                  ? "outofinstock-badge-style-dark"
                  : "outofinstock-badge-style"
                  }  p-2 font-size-12 sub-font m-1`}
              >
                {t("Out of stock")}
              </Badge>
            )}
          </p>
        )}
      </div>


      {item?.has_price_option_item && item?.price_option_items?.length ? (
        <div className="alignByLang">
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="row px-3 m-0"
          >
            <div className="col-6 p-0">
              <p
                className="fw-bold mt-3 font-size-22 head-font"
                style={{
                  textAlign:
                    localStorage.getItem("lang") === "ar" ||
                      localStorage.getItem("lang") === "fa"
                      ? "right"
                      : "left",
                }}
              >
                {item?.name}
                <br /> ({selected}){" "}
              </p>
            </div>
            <div className="col-4 p-0">
              <Swiper
                handleSelected={handleSelected}
                prices={item?.price_option_items}
                currency={sympoleData}
              />
            </div>
          </div>
        </div>
      ) : item?.price_options?.length > 0 ? (
        <div className="alignByLang">
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="row px-3 m-0"
          >
            <div className="col-6 p-0">
              <p
                className="fw-bold mt-3 font-size-22 head-font"
                style={{
                  textAlign:
                    localStorage.getItem("lang") === "ar" ||
                      localStorage.getItem("lang") === "fa"
                      ? "right"
                      : "left",
                }}
              >
                {item?.name}
                <br /> ({selected}){" "}
              </p>
            </div>
            <div className="col-4 p-0">
              <Swiper
                handleSelected={handleSelected}
                prices={item?.price_options}
                currency={sympoleData}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-between px-3 alignByLang">
          <p
            style={{ color: setMobileTextColor(), maxWidth: "70%" }}
            className="font-size-22 head-font"
          >
            {item?.name}
          </p>

          <p
            className="head-font"
            style={{
              color:
                localStorage.getItem("theme") === "costomize"
                  ? setMobileTextColor()
                  : "#6ba5f2",
            }}
          >
            <span>
              {item?.old_price > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                  }}
                >
                  {item.old_price || ""}
                </span>
              )}{" "}
              {item?.price} {sympoleData ? sympoleData === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympoleData : ""}
            </span>
          </p>
        </div>
      )}

      <div className="contents px-3 alignByLang">
        {item?.price_options?.length > 0 && calorie && calorie > 0 ? (
          <span
            className="fw-bold sub-font mr-1"
            style={{ color: setMobileTextColor() }}
          >
            <img src={calories} className="mr-1 calories_style" />{" "}
            {`${calorie ? calorie : 0} ${t("cal")}`}
          </span>
        ) : (
          item?.calories &&
          item?.calories > 0 &&
          item?.price_options?.length === 0 && (
            <span className={`head-font ${setMobileButttonBackColor()}`}>
              <img src={calories} className="mr-1 calories_style" />{" "}
              {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
            </span>
          )
        )}

        <span
          className="head-font mr-1"
          style={{ color: setMobileTextColor() }}
        >
          {(item?.max_preparation_time != null &&
            item?.max_preparation_time >= 0) ||
            (item?.min_preparation_time != null &&
              item?.min_preparation_time >= 0) ? (
            <img src={time} className="mr-1 timer_style" />
          ) : (
            ""
          )}

          {` ${item?.min_preparation_time === 0
            ? item?.min_preparation_time
            : !item?.min_preparation_time
              ? ""
              : item?.min_preparation_time
            } ${(!item?.max_preparation_time && item?.max_preparation_time !== 0) ||
              (!item?.min_preparation_time && item?.min_preparation_time !== 0)
              ? ``
              : `-`
            }   ${item?.max_preparation_time === 0
              ? item?.max_preparation_time
              : !item?.max_preparation_time
                ? ""
                : item?.max_preparation_time
            }
          
          ${(item?.max_preparation_time != null &&
              item?.max_preparation_time >= 0) ||
              (item?.min_preparation_time != null &&
                item?.min_preparation_time >= 0)
              ? t("min(s)") + " "
              : ""
            }
          `}
        </span>
        {item?.description && (
          <div className="mt-4">
            <p
              style={{ color: setMobileTextColor() }}
              className="font-size-16 head-font mb-2"
            >
              {t("Description")}
            </p>
            <p
              style={{ color: setMobileTextColor(), fontWeight: 400 }}
              className="font-size-12 sub-font"
            >
              {" "}
              {item?.description}
            </p>
          </div>
        )}
        <div className="mt-4">
          {item?.warnings?.length > 1 && (
            <p
              style={{ color: setMobileTextColor() }}
              className="font-size-16 head-font mb-2"
            >
              {t("warning ingredient")}
            </p>
          )}
          <div className="col-12">
            {item?.warnings?.map((element) => (
              <span key={element.id} className="alignByLang">
                <span
                  style={{ marginLeft: 2, marginRight: 5 }}
                  className="font-size-18 sub-font"
                >

                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                      marginLeft: 2,
                      marginRight: 5,
                    }}
                    src={ISDARKTHEME(localStorage.getItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element.icon_dark : element?.icon_light || element.icon}
                    onError={onImageError}
                    alt="icon"
                  />
                  {element.name}
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>


      {item?.is_combo_item && item?.comboItems?.length > 0 && (
        <div className="mt-4 sub-font" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2 className="sub-font" style={{ marginBottom: '2px', fontSize: '1rem', color: setMobileCardBorderColor(), textAlign: 'center' }}>
            {t("Combo Items")}
          </h2>

          <div
            style={{
              display: 'table',
              width: '90%',
              margin: '10px auto',
              textAlign: 'center',
            }}
          >
            {item?.comboItems?.map((comboItem, index) => (
              <div
                className="sub-font alignByLang"
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  backgroundColor: setMobileCardBorderColor(),
                  marginBottom: '10px',
                  padding: '5px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  borderRadius: '10px',
                }}

                onClick={() => openItem(comboItem)}
              >
                <div
                  style={{
                    width: '80px',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={comboItem?.image || no_image}
                    alt={t(item?.name)}
                    style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                    onError={onImageError}

                  />
                </div>
                <div style={{ flex: 1, textAlign: 'center' }}>
                  <span className="sub-font" style={{ color: setMobileTextColor() }}>{t(comboItem?.name)}</span>
                </div>
                <div style={{ flex: 1, textAlign: 'center' }}>
                  <span style={{ color: setMobileTextColor() }}>{comboItem?.quantity}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}





      {item?.recommended_items?.length > 0 && (
        <div
          className={`footer mt-4 p-24 w-100 alignByLang ${localStorage.getItem("mode") === "dark"
            ? "footer-dark"
            : "footer-light"
            }`}
          style={{
            color: setMobileTextColor(),
            marginBottom: "62px",
            borderBottom: "0px",
            borderLeft: "0px",
            borderRight: "0px",
          }}
        >
          <div className="row">
            <h2 style={{ color: setMobileTextColor() }} className="head-font">
              <strong>{t("Suggested items")}</strong>
            </h2>
            <ImageList
              sx={{
                gridAutoFlow: "column",
                gridTemplateColumns:
                  "repeat(auto-fill,minmax(160px,1fr)) !important",
                gridAutoColumns: "minmax(160px, 1fr)",
              }}
            >
              {item?.recommended_items.map(
                (element) =>
                  item?.id !== element.id && (
                    <ImageListItem
                      className="me-3"
                      key={element.id}
                      interval={3000}
                    >
                      <Dishe
                        item={element}
                        updataItem={updataItem}
                        // refetch={refetch}
                        qrCode={tableQr}
                        qrName={tableName}
                        favorites={favorites}
                        sympole={sympoleData}
                        handleFavorite={handleFavorite}
                        suggested={true}
                      />
                    </ImageListItem>
                  )
              )}
            </ImageList>
          </div>
        </div>
      )}

      <div
        className={`add-cart-button-containter`}
        style={{ backgroundColor: setMobileBackColor(), padding: 15 }}
      >
        <span className={`heart cursor`} onClick={() => handleFavorite(item)}>
          {favorites.findIndex((fav) => fav.id === item?.id) !== -1 ? (
            <img
              src={heart_full_active_svg}
              className="heart"
              style={{ width: "35px", height: "35px" }}
              onError={onImageError}
            />
          ) : (
            <img
              src={heart_full_inactive_svg}
              className="heart"
              style={{ width: "35px", height: "35px" }}
              onError={onImageError}
            />
          )}
        </span>
        {!treeData?.details?.order_ability && !treeData?.details?.whatsapp ? (
          true
        ) : (
          <Button
            className="btn text-center sub-font alignByLang mx-2"
            style={{
              backgroundColor: setMobileButttonBackColor(),
              color: setMobileTextColor(),
              width: "85%",
              fontSize: "16px",
              fontWeight: 600,
              zIndex: 9999,
              display: open ? "none" : "block",
            }}
            onClick={(e) => handleOrder(true,e)}
          >
            {t("Add to cart")}
          </Button>
        )}
      </div>

      <div></div>
    </div>
  );
};

export default MianInfo;
